import React, { useState, useEffect, useLayoutEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faBackspace } from '@fortawesome/free-solid-svg-icons';
import { BeatLoader } from 'react-spinners';
import {
  Wrapper, Background, Content, NumberContent,
  Row, Number, Input, Text, Loader,
} from './style';

interface Props {
  password: string,
  isOpen: boolean,
  isLoading: boolean,
  _handleOpen: ((isOpen: boolean) => void),
  _handlePassword: ((password: string) => void),
}

const NumberPad: React.FC<Props> = ({
  password='',
  isOpen=false,
  isLoading=false,
  _handleOpen,
  _handlePassword,
}) => {
  const [number, setNumber] = useState<any>(
    [[1, 2, 3], [4, 5, 6], [7, 8, 9], [0]]
  );

  useLayoutEffect(() => {
    if (isOpen) {
      _handlePassword('');
    }
    // eslint-disable-next-line
  }, [isOpen]);

  useEffect(() => {
    const numbers: Array<number> = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    let j, x, i: number;
    for (i = numbers.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = numbers[i];
      numbers[i] = numbers[j];
      numbers[j] = x;
    }
    
    const newNumbers = [
      numbers.slice(0, 3), numbers.slice(3, 6), numbers.slice(6, 9), numbers.slice(9),
    ];
    setNumber(newNumbers);
  }, []);

  const clickNumber = (number: number) => {
    if (password.length < 4) {
      _handlePassword(`${password}${number}`);
    }
  }

  const removeNumber = () => {
    let newPassword: (string) = password;
    _handlePassword(newPassword.slice(0, newPassword.length - 1));
  }

  return (
    <Wrapper isOpen={isOpen}>
      <Content>
        <Text>결제번호 4자리를 입력해주세요</Text>

        <Input
          type="text"
          maxLength={4}
          value={password}
          readOnly
        />

        <Loader className={`${isLoading ? 'show' : 'hide'}`}>
          <BeatLoader
            size={20}
            color={'#05d6e1'}
          />
        </Loader>

        <NumberContent className={`${isLoading ? 'hide' : 'show'}`}>
          <Row>
            {
              number[0].map((item: any, idx: number) => {
                return (
                  <Number
                    key={idx}
                    onClick={() => clickNumber(item)}
                    aria-haspopup="true"
                  >
                    {item}
                  </Number>
                )
              })
            }
          </Row>
          <Row>
            {
              number[1].map((item: any, idx: number) => {
                return (
                  <Number
                    key={idx}
                    onClick={() => clickNumber(item)}
                    aria-haspopup="true"
                  >
                    {item}
                  </Number>
                )
              })
            }
          </Row>
          <Row>
            {
              number[2].map((item: any, idx: number) => {
                return (
                  <Number
                    key={idx}
                    onClick={() => clickNumber(item)}
                    aria-haspopup="true"
                  >
                    {item}
                  </Number>
                )
              })
            }
          </Row>
          <Row>
            <Number aria-haspopup="true" onClick={() => _handleOpen(false)}>
              <FontAwesomeIcon icon={faTimes} />
            </Number>
            {
              number[3].map((item: any, idx: number) => {
                return (
                  <Number
                    key={idx}
                    onClick={() => clickNumber(item)}
                    aria-haspopup="true"
                  >
                    {item}
                  </Number>
                )
              })
            }
            <Number onClick={() => removeNumber()} aria-haspopup="true">
              <FontAwesomeIcon icon={faBackspace} />
            </Number>
          </Row>
        </NumberContent>
      </Content>
      <Background />
    </Wrapper>
  );
};

export default NumberPad;
